import { preferencesV2Selectors } from 'app-components/flux/preferences-v2';
import type RootState from 'app-components/utils/redux-store/rootState';
import { PROFILE_REDUCER_KEY } from './profileTypes';

type State = Pick<RootState, typeof PROFILE_REDUCER_KEY>;
// TODO: when prefsV2 is typed add prefsV2 reducer here

export const getProfileStore = (state: State) => state[PROFILE_REDUCER_KEY];

export const getIsLoading = (state: State) => getProfileStore(state).isLoading;
export const getLoadPending = (state: State) => getProfileStore(state).loadPending;
export const getError = (state: State) => getProfileStore(state).error;
export const getResourcesById = (state: State) => getProfileStore(state).resourcesById;

export const getProfile = (state: State) => getProfileStore(state).resourcesById.first();

export const getPhoneVerified = (state: State) => Boolean(getProfile(state)?.primaryPhone?.verified);

export const getEmailVerified = (state: State) => Boolean(getProfile(state)?.primaryEmail?.verified);

export const getIdentityVerified = (state: State) => Boolean(getProfileStore(state)?.verified);
export const getIdentityStatus = (state: State) => getProfileStore(state)?.status;
export const getVerificationAttemptsAvailable = (state: State) => {
  const store = getProfileStore(state);
  return Boolean(store && (store.verificationAttempts ?? 0) < (store.verificationThreshold ?? 1));
};

export const getVerificationAttemptedButIncomplete = (state: State) => {
  const store = getProfileStore(state);
  return Boolean(store && !store.verified && (store.verificationAttempts ?? 0) > 0);
};

// TODO: when prefsV2 is typed we can re-add state type here
export const getIdentityPending = (state: any) =>
  preferencesV2Selectors.getPreferenceValue(state, 'identityPending') as boolean;

export const isUserEligibleToMakeTransfers = (state: State) =>
  getIdentityVerified(state) && getPhoneVerified(state) && getEmailVerified(state);
